const gtag = function() {
  if (!analytics_loaded) return

  window.dataLayer.push(arguments)
}
let analytics_loaded = false

const loadAnalytics = function() {
  if (analytics_loaded) return

  window.dataLayer = window.dataLayer || []

  analytics_loaded = true

  const analyticsId = gon.analytics.id
  const url = 'https://www.googletagmanager.com/gtag/js'

  gtag('js', new Date())
  gtag('config', analyticsId)
}

const registerAnalyticsEvent = (name, params) => {
  gtag('event', name, params)
}

const trackEvent = (category, action, name, value) => {
  if (!window._paq) return

  window._paq.push(['trackEvent', category, action, name, value])
}

const trackSiteSearch = (searchTerms, category, resultsCount) => {
  if (!window._paq) return

  const searchQuery = searchTerms.join(' ')
  window._paq.push(['trackSiteSearch', searchQuery, category, resultsCount])
}

export { loadAnalytics, registerAnalyticsEvent, trackEvent, trackSiteSearch }
